export const removeSpecialCharacter = (text, ch) => {
  if (!text) return 'N/A';
  return text.replaceAll(ch, ' ');
};

export function capitalizeFirstLetter(text) {
  if (!text) return 'N/A';
  text = text.toLowerCase();
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export const getInitials = (name) => {
  const nameParts = name?.split(' ');
  if (nameParts.length === 1) {
    return nameParts[0]?.charAt(0)?.toUpperCase();
  } else {
    return (
      nameParts[0]?.charAt(0)?.toUpperCase() +
      nameParts[nameParts.length - 1]?.charAt(0)?.toUpperCase()
    );
  }
};

export const formatNumber = (num) => {
  return new Intl.NumberFormat('en-US').format(num);
};